import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

import { SizingMultiplier } from '@ocx/ui';

type MapToolbarProps = {
  children: ReactNode;
};

export const MapToolbar: React.FC<MapToolbarProps> = (props) => {
  const { children } = props;

  return (
    <Box
      display="flex"
      justifyContent="center"
      py={SizingMultiplier.md}
      px={SizingMultiplier.sm}
      position="absolute"
      left={0}
      right={0}
      sx={{
        zIndex: (theme) => theme.zIndex.fab + 2,
      }}>
      {children}
    </Box>
  );
};
